const CaseFilesInternal = {
        Yes: true,
        No: false
}
export default CaseFilesInternal